import { render } from "./MobileModule.vue?vue&type=template&id=704b8efe&scoped=true"
import script from "./MobileModule.vue?vue&type=script&lang=js"
export * from "./MobileModule.vue?vue&type=script&lang=js"

import "./MobileModule.vue?vue&type=style&index=0&id=704b8efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704b8efe"]])

export default __exports__